export const CLEAR_CREDENTIALS = 'Auth/CLEAR_CREDENTIALS';

export const EMPTY_AUTH = 'Auth/EMPTY_AUTH';

export const FETCH_LOGGED_IN_USER = 'Auth/FETCH_LOGGED_IN_USER';
export const FETCH_LOGGED_IN_USER_SUCCESS = 'Auth/FETCH_LOGGED_IN_USER_SUCCESS';
export const FETCH_LOGGED_IN_USER_FAILURE = 'Auth/FETCH_LOGGED_IN_USER_FAILURE';

export const FETCH_LOGIN = 'Auth/FETCH_LOGIN';
export const FETCH_LOGIN_SUCCESS = 'Auth/FETCH_LOGIN_SUCCESS';
export const FETCH_LOGIN_SUCCESS_NOT_ADMIN = 'Auth/FETCH_LOGIN_SUCCESS_NOT_ADMIN';
export const FETCH_LOGIN_FAILURE = 'Auth/FETCH_LOGIN_FAILURE';

export const FETCH_RESET_PASSWORD = 'Auth/FETCH_RESET_PASSWORD';
export const FETCH_RESET_PASSWORD_SUCCESS = 'Auth/FETCH_RESET_PASSWORD_SUCCESS';
export const FETCH_RESET_PASSWORD_FAILURE = 'Auth/FETCH_RESET_PASSWORD_FAILURE';

export const SET_CREDENTIALS = 'Auth/SET_CREDENTIALS';
export const SET_RESET_PASSWORD_DATA = 'Auth/SET_RESET_PASSWORD_DATA';
export const SET_TOKEN = 'Auth/SET_TOKEN';
export const SET_USER = 'Auth/SET_USER';
export const UPDATE_AUTH = 'Auth/UPDATE_AUTH';



// WEBPACK FOOTER //
// ./src/containers/Auth/store/constants.js